import {PencilIcon, RepoIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {useEffect, useRef} from 'react'
import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'

import type {TemplatePickerButton$key} from './__generated__/TemplatePickerButton.graphql'
import {LABELS} from './constants/labels'
import {useIssueCreateConfigContext} from './contexts/IssueCreateConfigContext'
import styles from './TemplatePickerButton.module.css'
import {DisplayMode} from './utils/display-mode'
import type {IssueCreatePayload} from './utils/model'

export type TemplatePickerButtonProps = {
  repository: TemplatePickerButton$key
  template: IssueCreatePayload | undefined
}

export function TemplatePickerButton({repository, template}: TemplatePickerButtonProps) {
  const data = useFragment(
    graphql`
      fragment TemplatePickerButton on Repository {
        nameWithOwner
        hasAnyTemplates
      }
    `,
    repository,
  )
  const {setDisplayMode} = useIssueCreateConfigContext()
  const templateText = template ? template.name : LABELS.blankIssueName
  const templatePickerButtonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    templatePickerButtonRef.current?.focus()
  }, [])

  if (!data.hasAnyTemplates) {
    return null
  }

  return (
    <div data-testid="template-picker-button" className={styles.TemplatePickerButtonContainer}>
      <Button
        data-testid="template-picker-button-el"
        onClick={() => setDisplayMode(DisplayMode.TemplatePicker)}
        leadingVisual={RepoIcon}
        trailingVisual={PencilIcon}
        ref={templatePickerButtonRef}
      >
        {data && (
          <span>
            {templateText} <span className={styles.repositoryConnectorText}>in</span> {data.nameWithOwner}
          </span>
        )}
        {!repository && <>Select a repository</>}
      </Button>
    </div>
  )
}

try{ TemplatePickerButton.displayName ||= 'TemplatePickerButton' } catch {}